module.exports = __webpack_public_path__ + "static/media/133.09b15933.webp";